import { StickyTable } from './StickyTable';
export default StickyTable;
